import React, { useCallback } from 'react';
import { Button } from '../../../../../atoms/Button/Button';
import { Text } from '../../../../../atoms/Text/Text';
import { isSafeLink, openSafeUrl } from '../../../utils/openSafeUrl';
import { ACTIONABLE_VISIT_STATUSES, UNLABELLED_VISIT_STATUSES, VISIT_STATUS_TEXT_KEY } from '../../constants';
import { dayBriefCardText } from '../../helpers';
import './DayBriefVisitRowStyles.scss';
const baseClass = 'qmb-ui-DayBriefVisitRow';
/**
 * One visit within a stop. The next (or in-progress) visit carries the action
 * buttons; a button whose URL the server could not build is left out rather
 * than rendered dead.
 */
export function DayBriefVisitRow({ visit, buildingName, directionsUrl }) {
    // A link the widget would refuse to open is as dead as a missing one, so it hides its button too.
    const openUrl = visit.open_url && isSafeLink(visit.open_url) ? visit.open_url : null;
    const directions = directionsUrl && isSafeLink(directionsUrl) ? directionsUrl : null;
    const showActions = ACTIONABLE_VISIT_STATUSES.has(visit.status) && Boolean(openUrl || directions);
    // A status the server adds later has no key: it renders unlabelled rather than throwing.
    const statusKey = VISIT_STATUS_TEXT_KEY[visit.status];
    const showStatus = statusKey !== undefined && !UNLABELLED_VISIT_STATUSES.has(visit.status);
    const handleOpenVisit = useCallback(() => {
        if (openUrl)
            openSafeUrl(openUrl);
    }, [openUrl]);
    const handleDirections = useCallback(() => {
        if (directions)
            openSafeUrl(directions);
    }, [directions]);
    return (React.createElement("li", { className: baseClass },
        React.createElement(Text, { variant: "small", className: `${baseClass}__time` }, visit.time),
        React.createElement("div", { className: `${baseClass}__body` },
            React.createElement(Text, { variant: "body" },
                React.createElement("span", { className: `${baseClass}__type` }, visit.type),
                ' ',
                React.createElement("span", { className: `${baseClass}__muted` }, visit.reference)),
            visit.detail && (React.createElement(Text, { variant: "body", className: `${baseClass}__detail ${baseClass}__muted` }, visit.detail)),
            showActions && (React.createElement("div", { className: `${baseClass}__actions` },
                openUrl && (React.createElement(Button, { variant: "primary", className: `${baseClass}__action`, "aria-label": dayBriefCardText('open_visit_for', { reference: visit.reference }), onClick: handleOpenVisit }, dayBriefCardText('open_visit'))),
                directions && (React.createElement(Button, { variant: "secondary", className: `${baseClass}__action`, "aria-label": dayBriefCardText('directions_to', { name: buildingName }), onClick: handleDirections },
                    React.createElement("i", { className: "fa-solid fa-location-arrow", "aria-hidden": "true" }),
                    dayBriefCardText('directions')))))),
        showStatus && (React.createElement(Text, { variant: "x-small", className: `${baseClass}__status ${baseClass}__status--${visit.status}` }, dayBriefCardText(statusKey)))));
}
